import * as AlertActions from './alert';
import * as AuthActions from './auth';
import * as Itemlookup from './itemlookup';
import * as LocationsActions from './locations';
import * as NpcByBrandActions from './npcByBrand';
import * as NpcByItemActions from './npcByItem';
import * as NpcFbaFreightActions from './npcFbaFreight';
import * as NpcInboundFreightActions from './npcInboundFreight';
import * as NpcStorageActions from './npcStorage';
import * as UserActions from './user';
import * as WarehouseActions from './warehouse';

const allActions = {
  ...UserActions,
  ...AuthActions,
  ...AlertActions,
  ...NpcByBrandActions,
  ...NpcByItemActions,
  ...WarehouseActions,
  ...NpcFbaFreightActions,
  ...NpcStorageActions,
  ...NpcInboundFreightActions,
  ...Itemlookup,
  ...LocationsActions
};

export default allActions;
